import React from "react";

const CartSummary = ({ getTotalBill, contestData }) => {
  const {
    showContest,
    eligible,
    minimumPurchaseAmount,
    reason,
    totalPurchasesInMonth,
  } = contestData || {};
  // console.log(
  //   "Cart Summary Contest Data",
  //   showContest,
  //   eligible,
  //   minimumPurchaseAmount,
  //   reason
  // );

  return (
    <div style={{ marginBottom: "10px" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          backgroundColor: "#ffff",
          color: "#333",
          padding: "20px 20px 0px 20px",
          borderRadius: "10px 10px 0 0",
        }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <i className="fa fa-shopping-cart" style={{ marginRight: "10px" }} />
          <span style={{ fontSize: "15px", fontWeight: "bold" }}>Cart</span>
        </div>

        {/* <div>
          {JSON.stringify(contestData)}
        </div> */}

        <div>
          <span style={{ fontSize: "16px", fontWeight: "bold" }}>
            Total Bill: {getTotalBill()}
          </span>
        </div>
      </div>

      <div
        style={{
          backgroundColor: "#fff",
          padding: "10px 20px",
          borderRadius: "0 0 10px 10px",
        }}
      >
        {reason && (
          <div style={{ marginBottom: "10px" }}>
            <span
              style={{
                fontSize: "16px",
                fontWeight: "bold",
                color: "#4CAF50",
              }}
            >
              {reason}
            </span>
          </div>
        )}

        {showContest && eligible && (
          <div>
            {
              // totalPurchasesInMonth < minimumPurchaseAmount &&
              <>
                <div style={{ marginBottom: "10px" }}>
                  <span
                    style={{
                      fontSize: "16px",
                      fontWeight: "bold",
                      color: "#333",
                    }}
                  >
                    To participate in the contest the sum of order amount need
                    to be above{" "}
                    <span style={{ color: "#4CAF50" }}>
                      ₹{minimumPurchaseAmount || 0}
                    </span>
                    {/* <br />
                    <small>The progress bar shows your current montly spend for completed orders, also sum of total cart value</small> */}
                  </span>
                </div>
                <div
                  style={{ marginTop: "8px", fontSize: "12px", color: "#666" }}
                >
                  ₹
                  {totalPurchasesInMonth + getTotalBill() >
                  minimumPurchaseAmount
                    ? minimumPurchaseAmount + " + "
                    : totalPurchasesInMonth + getTotalBill()}{" "}
                  / ₹{minimumPurchaseAmount || 0}
                </div>
                <div
                  style={{
                    width: "100%",
                    height: "8px",
                    backgroundColor: "#e0e0e0",
                    borderRadius: "4px",
                    overflow: "hidden",
                  }}
                >
                  <div
                    style={{
                      width: `${Math.min(
                        ((totalPurchasesInMonth + getTotalBill()) /
                          minimumPurchaseAmount || 0) * 100,
                        100
                      )}%`,
                      height: "100%",
                      backgroundColor: "#4285f4",
                      borderRadius: "4px",
                      transition: "width 0.3s ease",
                    }}
                  />
                </div>
                {/* <small>Current Month Spend: ₹{totalPurchasesInMonth}</small> */}
                <small>
                  The progress bar shows your current montly spend for completed
                  orders + total cart value
                </small>
              </>
            }
          </div>
        )}
      </div>
    </div>
  );
};

export default CartSummary;
